import styled from "styled-components";
import {LiveCasinoGridItemDrawDefaultBox} from "./live-casino-grid-item-draw.default.box";
import {GREEN, RED} from '../../../css-constants';

export const LiveCasinoGridItemDrawCasino777Box = styled(LiveCasinoGridItemDrawDefaultBox)`
  color: ${props => props.theme.colors.buttonDark};

  &:first-child {
    color: ${props => props.theme.colors.buttonLight};
    background: ${props => props.theme.colors.buttonDark};
  }

  &.${RED} {
    color: ${props => props.theme.components.newLiveCasino.colors.gridItem.drawRedItemBackground};

    &:first-child {
      color: ${props => props.theme.colors.buttonLight};
      background: ${props => props.theme.components.newLiveCasino.colors.gridItem.drawRedItemFirstChildBackground};
    }
  }

  &.${GREEN} {
    color: ${props => props.theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground};

    &:first-child {
      color: ${props => props.theme.colors.buttonLight};
      background: ${props => props.theme.components.newLiveCasino.colors.gridItem.drawGreenItemFirstChildBackground};
    }
  }
`;
